import { notifications } from '@mantine/notifications';
import { IconCreditCard, IconExclamationCircle } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateChargeMutation } from '../hooks/useCreateChargeMutation';
import MethodPanel from './MethodPanel';
import TopupAmountForm from './TopupAmountForm';

export default function CreditCardMethod() {
    const { t } = useTranslation('topup');
    const mutation = useCreateChargeMutation();
    const [amount, setAmount] = useState<number>(50);
    const [agreed, setAgreed] = useState(false);

    const handleSubmit = async () => {
        if (!window.OmiseCard) {
            notifications.show({
                title: t('toast.errorTitle'),
                message: t('errors.omiseUnavailable'),
                icon: <IconExclamationCircle size={18} color="#eb5757" />,
            });
            return;
        }

        window.OmiseCard.open({
            amount: amount * 100,
            currency: 'THB',
            defaultPaymentMethod: 'credit_card',
            onCreateTokenSuccess: async (nonce) => {
                try {
                    const charge = await mutation.mutateAsync({
                        amount,
                        currency: 'THB',
                        redirectURL: window.location.origin,
                        token: nonce,
                    });
                    window.location.href = charge.redirectURL;
                } catch {
                    // Error already surfaced via mutation onError toast.
                }
            },
            onFormClosed: () => {
                notifications.show({
                    title: t('toast.errorTitle'),
                    message: t('errors.cardCancelled'),
                    icon: <IconExclamationCircle size={18} color="#eb5757" />,
                });
            },
        });
    };

    return (
        <MethodPanel
            icon={IconCreditCard}
            title={t('methods.creditCard.title')}
            tagline={t('methods.creditCard.tagline')}
        >
            <TopupAmountForm
                amount={amount}
                onAmountChange={setAmount}
                agreed={agreed}
                onAgreedChange={setAgreed}
                submitting={mutation.isPending}
                onSubmit={handleSubmit}
            />
        </MethodPanel>
    );
}
